import { api } from './client'
import type { Expense } from '@/types/farmexpenses'

const BASE_URL = 'supervisor/farm/expenses/' // ← Note: trailing slash

export const getExpenses = () => api.get<Expense[]>(BASE_URL)

export const createExpense = (data: Partial<Expense>) =>
  api.post<Expense>(BASE_URL, data) // ✅ POST to /expenses/

export const updateExpense = (id: string, data: Partial<Expense>) =>
  api.put<Expense>(`${BASE_URL}${id}/`, data) // ✅ /expenses/123/

export const deleteExpense = (id: string) =>
  api.delete(`${BASE_URL}${id}/`) // ✅ /expenses/123/
